module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "summary-heading"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "damagesReserve",
      "label": "Damages Reserve:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.damagesReserve),
      expression: "damagesReserve",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "damagesReserve",
      "id": "damagesReserve",
      "maxlength": "100",
      "type": "number"
    },
    domProps: {
      "value": (_vm.damagesReserve)
    },
    on: {
      "focus": function($event) {
        _vm.damagesReserve = _vm.damagesReserve || ''
      },
      "blur": [function($event) {
        _vm.damagesReserve = _vm.damagesReserve || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.damagesReserve = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "thirdPartyReserve",
      "label": "Third Party Costs Reserve:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.thirdPartyReserve),
      expression: "thirdPartyReserve",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "thirdPartyReserve",
      "id": "thirdPartyReserve",
      "maxlength": "100",
      "type": "number"
    },
    domProps: {
      "value": (_vm.thirdPartyReserve)
    },
    on: {
      "focus": function($event) {
        _vm.thirdPartyReserve = _vm.thirdPartyReserve || ''
      },
      "blur": [function($event) {
        _vm.thirdPartyReserve = _vm.thirdPartyReserve || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thirdPartyReserve = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "defenceCostsReserve",
      "label": "Defence Costs Reserve:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.defenceCostsReserve),
      expression: "defenceCostsReserve",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "defenceCostsReserve",
      "id": "defenceCostsReserve",
      "maxlength": "100",
      "type": "number"
    },
    domProps: {
      "value": (_vm.defenceCostsReserve)
    },
    on: {
      "focus": function($event) {
        _vm.defenceCostsReserve = _vm.defenceCostsReserve || ''
      },
      "blur": [function($event) {
        _vm.defenceCostsReserve = _vm.defenceCostsReserve || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.defenceCostsReserve = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "paidDamages",
      "label": "Paid Damages:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.paidDamages),
      expression: "paidDamages",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "paidDamages",
      "id": "paidDamages",
      "maxlength": "100",
      "type": "number"
    },
    domProps: {
      "value": (_vm.paidDamages)
    },
    on: {
      "focus": function($event) {
        _vm.paidDamages = _vm.paidDamages || ''
      },
      "blur": [function($event) {
        _vm.paidDamages = _vm.paidDamages || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paidDamages = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "paidThirdPartyCosts",
      "label": "Paid Third Party Costs:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.paidThirdPartyCosts),
      expression: "paidThirdPartyCosts",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "paidThirdPartyCosts",
      "id": "paidThirdPartyCosts",
      "maxlength": "100",
      "type": "number"
    },
    domProps: {
      "value": (_vm.paidThirdPartyCosts)
    },
    on: {
      "focus": function($event) {
        _vm.paidThirdPartyCosts = _vm.paidThirdPartyCosts || ''
      },
      "blur": [function($event) {
        _vm.paidThirdPartyCosts = _vm.paidThirdPartyCosts || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paidThirdPartyCosts = _vm._n($event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "paidDefenceCosts",
      "label": "Paid Defence Costs:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.paidDefenceCosts),
      expression: "paidDefenceCosts",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "paidDefenceCosts",
      "id": "paidDefenceCosts",
      "maxlength": "100",
      "type": "number"
    },
    domProps: {
      "value": (_vm.paidDefenceCosts)
    },
    on: {
      "focus": function($event) {
        _vm.paidDefenceCosts = _vm.paidDefenceCosts || ''
      },
      "blur": [function($event) {
        _vm.paidDefenceCosts = _vm.paidDefenceCosts || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paidDefenceCosts = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "recoveredCosts",
      "label": "Recovered Costs:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.recoveredCosts),
      expression: "recoveredCosts",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "recoveredCosts",
      "id": "recoveredCosts",
      "maxlength": "100",
      "type": "number"
    },
    domProps: {
      "value": (_vm.recoveredCosts)
    },
    on: {
      "focus": function($event) {
        _vm.recoveredCosts = _vm.recoveredCosts || ''
      },
      "blur": [function($event) {
        _vm.recoveredCosts = _vm.recoveredCosts || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recoveredCosts = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "totalInitialReserve",
      "label": "Total Reserve:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.totalReserve || 0
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "netPaid",
      "label": "Net Paid:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": _vm.netPaid || 0
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "totalPaid",
      "label": "Total Paid:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": _vm.totalPaid || 0
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "netPaid",
      "label": "Net Paid:",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.netPaid),
      expression: "netPaid",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "netPaid",
      "id": "netPaid",
      "maxlength": "100",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.netPaid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.netPaid = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin"
  }, [_c('div', {
    staticClass: "flex-grid__g-2 flex-grid--input-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-7"
  }, [_c('button', {
    staticClass: "a-button a-button--loader-button",
    class: [_vm.isSaving ? 'a-loader--white' : ''],
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_c('span', {
    class: [_vm.isSaving ? 'a-button--span-hidden' : '']
  }, [_vm._v("Save")])]), _vm._v(" "), (_vm.showBackBtn) ? _c('button', {
    staticClass: "a-button a-button--no-margin",
    on: {
      "click": function($event) {
        return _vm.close('showAllSummary')
      }
    }
  }, [_vm._v(_vm._s(this.modal ? 'Close' : 'Back') + "\n                    ")]) : _vm._e()])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e7b4d85!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/claims-dashboard/components/InitialReservesCosts.vue
// module id = 1598
// module chunks = 0